// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2hcaj","info":"PatientInfo_info__1fyeO"};